module.exports = __webpack_public_path__ + "static/media/20.6e677140.png";